<script setup lang="ts">
interface Props {
  alignItems?: string;
  justifyContent?: string;
  gap?: number;
  minWidth?: string;
  maxWidth?: string;
  width?: string;
  height?: string;
  flex?: string;
}

withDefaults(defineProps<Props>(), {
  alignItems: undefined,
  justifyContent: undefined,
  gap: 1,
  minWidth: undefined,
  maxWidth: undefined,
  width: undefined,
  height: undefined,
  flex: undefined,
});
</script>

<template>
  <div
    class="stack"
    :style="{
      alignItems,
      justifyContent,
      gap: `${gap}rem`,
      minWidth,
      width,
      maxWidth: maxWidth || width,
      height,
      flex,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use './Stack.scss';
</style>
